module.exports = "/images/trianglify-bw-50@2x.png?0cb78e0bd2fec521e73b2ad5bbc779a1";